package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagCs: ImageVector
    get() {
        if (_flagCs != null) {
            return _flagCs!!
        }
        _flagCs = Builder(name = "FlagCs", defaultWidth = 512.0.dp, defaultHeight = 512.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 256.0f)
                    lineTo(0.0f, 256.0f)
                    lineTo(0.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFD7141A)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(0.0f, 256.0f)
                    lineTo(512.0f, 256.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    lineTo(0.0f, 256.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF11457E)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(300.0f, 256.0f)
                    lineTo(0.0f, 56.0f)
                    lineTo(0.0f, 456.0f)
                    lineTo(300.0f, 256.0f)
                    close()
                }
            }
        }
        .build()
        return _flagCs!!
    }

private var _flagCs: ImageVector? = null
